import React, { createContext, useContext, useState } from "react";

interface ProcessContextProps {
  selectedProcessType: number;
  setSelectedProcessType: (value: number) => void;
  logId: number | null;
  setLogId: (value: number | null) => void;
}

const ProcessContext = createContext<ProcessContextProps | undefined>(undefined);

export const ProcessProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedProcessType, setSelectedProcessType] = useState<number>(0);
  const [logId, setLogId] = useState<number | null>(null);

  return (
    <ProcessContext.Provider value={{ selectedProcessType, setSelectedProcessType, logId, setLogId }}>
      {children}
    </ProcessContext.Provider>
  );
};

export const useProcessContext = (): ProcessContextProps => {
  const context = useContext(ProcessContext);
  if (!context) {
    throw new Error("useProcessContext must be used within a ProcessProvider");
  }
  return context;
};